import type { NativeToolbarSearchBarSlotProps } from './types';

export const NativeToolbarSearchBarSlot: React.FC<NativeToolbarSearchBarSlotProps> = () => null;
